import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

interface ApiRow {
  readonly apiId: string;
  readonly apiCode: string;
  readonly apiName: string;
  readonly apiType: string;
  readonly version: string;
  readonly status: string;
}

export function M20ApiGatewayDashboardPage(): ReactNode {
  const { t } = useTranslation();
  const { token } = useAuth();
  const [rows, setRows] = useState<ApiRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<{ data: ApiRow[] }>('/v1/integration/gateway/apis', { token })
      .then((r) => { if (alive) setRows(r.data); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('m20.apiGateway.loading')}</p>;
  return (
    <main aria-label="api-gateway-dashboard">
      <h1>{t('m20.apiGateway.title')}</h1>
      <table aria-label="api-catalogue-table">
        <thead><tr><th>{t('m20.apiGateway.colCode')}</th><th>{t('m20.apiGateway.colName')}</th><th>{t('m20.apiGateway.colType')}</th><th>{t('m20.apiGateway.colVersion')}</th><th>{t('m20.apiGateway.colStatus')}</th></tr></thead>
        <tbody>
          {rows.map((a) => (
            <tr key={a.apiId}>
              <td>{a.apiCode}</td>
              <td>{a.apiName}</td>
              <td>{a.apiType}</td>
              <td>{a.version}</td>
              <td>{a.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
